module.exports = __webpack_public_path__ + "static/keyboard-501795e42027dfd9b92e7da3b26b5565.jpg";